/*
 * @Author: cc
 * @Date: 2021-03-26 10:28:25
 * @LastEditTime: 2021-03-26 18:17:53
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\manuscriptType\manuscriptType.js
 * @Description: 稿件类型
 */
angular.module('editingCenterModule').directive('editManuscriptType', ['publicToolService', function (publicToolService) {
    return {
        scope: true, // 继承作用域
        restrict: 'EA',
        templateUrl: './editingCenter/directive/manuscriptType/index.html',
        link: function ($scope) {
            init();
            initOrigin();

            /**
             * [init description] 初始化
             * @return  {[type]}  [return description]
             */
            function init() {
                $scope.originList = [
                    {
                        name: '内部原创',
                        value: '2',
                    },
                    {
                        name: '整合原创',
                        value: '1',
                    },
                    {
                        name: '特约稿',
                        value: '3',
                    },
                    {
                        name: '通讯员稿',
                        value: '4',
                    },
                    {
                        name: '报道组稿',
                        value: '5',
                    },
                    {
                        name: '其他',
                        value: '6',
                    },
                ];

                /**
                * [checkOrigin description]
                * @param   {[type]}  item  [item description]
                * @return  {[type]}        [return description]
                */
                $scope.checkOrigin = function (item) {
                    $('.newsResourcesTips')
                        .find('.tips')
                        .remove();
                    $scope.data.originType = item.value;
                    $scope.list.ORIGINAL = '1';
                    $scope.data.specialDoc = 0;
                };
                publicToolService.getModeconfiguration('draftDefaultOrigin').then((config) => {
                    if (config.origin && !$scope.list.TITLE) { // 如果默认配置自选中，则勾选,$scope.list.TITLE表示稿件已处于编辑模式，编辑默认不做默认填充
                        $scope.oringin($scope.list);
                    }
                });
            }

            /**
             * [initOrigin description] 初始化原创
             * @return  {[type]}  [return description]
             */
            function initOrigin() {
                // if ($state.params.iwometadataid || !$state.params.appmetadataid) {
                //     return;
                // }
                for (var i = 0; i < $scope.originList.length; i++) {
                    if ($scope.list.ORIGINALTYPE === $scope.originList[i].value) {
                        $scope.checkOrigin($scope.originList[i]);
                        break;
                    }
                }
                $scope.data.specialDoc = $scope.list.SPECIALDOC || 0;
            }

            /**
             * [oringin description]
             * @param   {[type]}  list  [list description]
             * @return  {[type]}        [return description]
             */
            $scope.oringin = function (list) {
                if (list.ORIGINAL === '1') {
                    $scope.list.ORIGINAL = '0';
                    $scope.data.originType = '0';
                } else {
                    $('.newsResourcesTips')
                        .find('.tips')
                        .remove();
                    $scope.list.ORIGINAL = '1';
                    $scope.data.originType = $scope.originList[0].value;
                    $scope.data.specialDoc = 0;
                }
            };

            /**
             * [specialDoc description]
             * @return  {[type]}  [return description]
             */
            $scope.specialDoc = function () {
                if ($scope.data.specialDoc * 1 === 1) {
                    $scope.data.specialDoc = 0;
                } else {
                    $('.newsResourcesTips')
                        .find('.tips')
                        .remove();
                    $scope.data.specialDoc = 1;
                    $scope.list.ORIGINAL = '0';
                    $scope.data.originType = '0';
                }
            };
        }
    };
}]);
